import React,{ useEffect } from "react";
import "./About.css";
import { useLocation } from "react-router-dom";

import { FaLinkedin } from "react-icons/fa";

export default function AboutUs() {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);
  return (
    <div className="container">
      {/* About Us Section */}
      <section className="section about-us-section full-width">
        <h2 className="section-title-first">About Us</h2>
        <p className="section-text-first">
          At Data Bolta Hai, we are pioneers in data analytics, offering cutting-edge solutions 
          to optimize business processes. Our expert team of professionals combines deep industry 
          knowledge with advanced IT tools and mathematical algorithms to uncover hidden insights.
          We help clients make data-driven decisions with precision, offering services like GST 
          reconciliation and tailored big data solutions. Our approach is transparent, ensuring 
          we maintain the highest standards of confidentiality and integrity in all our engagements.
        </p>
      </section>

      {/* Mission Section */}
      <section id="mission-section" className="section mission-section full-width">
        <h2 className="section-title">Our Mission</h2>
        <div className="mission-content">
          <p className="section-text">
            Our mission is to empower organizations to unlock the full potential of their data. 
            By harnessing innovative technologies, we provide actionable insights that foster growth, 
            improve decision-making, and drive efficiency. We aim to transform raw data into strategic
            assets, helping our clients make informed, timely choices.
          </p>
          <img 
            src="../mission.png" 
            alt="Mission" 
            className="mission-image" 
          />
        </div>
      </section>

      {/* Vision Section */}
      <section className="section vision-section full-width">
        <div className="vision-content">
          <img 
            src="../vision.png" 
            alt="Vision" 
            className="vision-image" 
          />
          <div className="vision-text">
            <h2 className="section-title">Our Vision</h2>
            <p className="section-text">
              We aspire to become a global leader in data analytics, offering businesses 
              innovative solutions to stay ahead of the curve. By enabling organizations to 
              effectively leverage data, our vision is to contribute to their success and growth, 
              ultimately shaping a future where data-driven decisions define success across industries.
            </p>
          </div>
        </div>
      </section>

      {/* Our Team Section */}
      <section id="team-section" className="section team-section full-width">
        <h2 className="section-title">Mentors and Promoters</h2>
        <div className="team-grid">
          <div className="team-member">
            <img src="./amit.jpg" alt="//" className="team-image" />
            <h3 className="team-name">Amit Kumar Heda</h3>
            <p className="team-role">Amit Kumar Heda is a Chartered Accountant and Company 
              Secretary with 15+ years of expertise in accounting, auditing, 
              and data mining. Skilled in forensic accounting, fraud detection, 
              and programming, he actively engages in professional seminars. 
              <br></br>
              <br></br>
              <a
             href="https://www.linkedin.com/in/amit-heda-03014919"
             target="_blank"
             rel="noopener noreferrer">
              <FaLinkedin size={24} color="#0077B5" />
             </a>
              </p>
          </div>
          {/* <div className="team-member">
            <img src="https://via.placeholder.com/150" alt="//" className="team-image" />
            <h3 className="team-name">Sanyam Maheshwari</h3>
            <p className="team-role"> </p>
          </div>
          <div className="team-member">
            <img src="https://via.placeholder.com/150" alt="//" className="team-image" />
            <h3 className="team-name">Deepti Heda</h3>
            <p className="team-role"> </p>
          </div>
          <div className="team-member">
            <img src="https://via.placeholder.com/150" alt="//" className="team-image" />
            <h3 className="team-name">Shweta Kabra</h3>
            <p className="team-role"> </p>
          </div>*/}
          </div> 
          </section>



          {/*<section id="team-section" className="section team-section full-width">
        <h2 className="section-title">Mentors and Promoters</h2>
        <div className="team-grid">
          <div className="team-member">
            <img src="https://via.placeholder.com/150" alt="//" className="team-image" />
            <h3 className="team-name">Amit Kumar Heda</h3>
            <p className="team-role"> </p>
          </div>
           <div className="team-member">
            <img src="https://via.placeholder.com/150" alt="//" className="team-image" />
            <h3 className="team-name">Sanyam Maheshwari</h3>
            <p className="team-role"> </p>
          </div>
          <div className="team-member">
            <img src="https://via.placeholder.com/150" alt="//" className="team-image" />
            <h3 className="team-name">Deepti Heda</h3>
            <p className="team-role"> </p>
          </div>
          <div className="team-member">
            <img src="https://via.placeholder.com/150" alt="//" className="team-image" />
            <h3 className="team-name">Shweta Kabra</h3>
            <p className="team-role"> </p>
          </div>
          </div> 
          </section>*/}

          <section className="section team-member-section full-width">
           <h2 className="section-title">Team Members</h2>
            <div className="team-grid">
          <div className="team-member">
            <img src="../nishant.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Nishant Lohar</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/nishant-lohar-233779253"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
            <img src="../varun.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Varun Thakkar</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/varun-thakkar-178969326"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
          <img src="../paresh.jpg" alt="//" className="team-image" />
            <h3 className="team-name">Paresh Sharma</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/paresh-sharma-40377a253"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
          <img src="../yash.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Yash Soni</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/yash-soni-782583253"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
          <img src="../dinesh.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Dinesh Singh</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/dinesh-singh-4068b7253"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
          <img src="../suyog.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Suyog Yadav</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/suyog-yadav-0a13a4298"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
          <img src="../shruti.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Shruti Tiwari</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/shruti-tiwari-1ba827253"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
          <img src="../manvi.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Manvi Pandey</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/manvi-pandey-7a9886292"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
          <div className="team-member">
          <img src="../radha.jpeg" alt="//" className="team-image" />
            <h3 className="team-name">Radha Singh</h3>
            <p className="team-role">
            <a
             href="https://www.linkedin.com/in/radha-singh-812712253/"
             target="_blank"
             rel="noopener noreferrer"
             >
             <FaLinkedin size={24} color="#0077B5" />
             </a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
